import { EmailTheme } from "../types/EmailTheme";

export const getCostScoreColors = (
  costScore: number,
  emailTheme: EmailTheme,
): string[] => {
  const maxScore = 5;
  const roundedScore = Math.round(costScore);
  const { colors } = emailTheme;

  const getActiveColor = (score: number) => {
    if (score <= 2) return colors.costScoreLow;
    if (score === 3) return colors.costScoreMedium;
    return colors.costScoreHigh;
  };

  return [...Array(maxScore)].map((_, index) =>
    index < roundedScore
      ? getActiveColor(roundedScore)
      : colors.costScoreInactive,
  );
};
